/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { CartUtilities } from '../../Utilities/cart-utils';

import { IClearWineclubData } from './clear-wineclub.data';
import { IClearWineclubProps } from './clear-wineclub.props.autogenerated';

export interface IClearWineclubViewProps extends IClearWineclubProps<IClearWineclubData> {

}

/**
 *
 * ClearWineclub component
 * @extends {React.PureComponent<IClearWineclubProps<IClearWineclubData>>}
 */
class ClearWineclub extends React.PureComponent<IClearWineclubProps<IClearWineclubData>> {

    private _didClearWineClub: boolean = false;

    public render(): JSX.Element | null {

        if (!this._didClearWineClub && this.props.data.cart.result) {
            void CartUtilities.removeCartHeadExtensionProps(
                this.props.data.cart,
                this.props.context,
                'WC First Name',
                'WC Last Name',
                'Gift recipient Email',
                'Gift recipient Phone Number',
                'Gift membership end date',
                'WC signup',
                'IsGiftedMembership',
                'Wine club delivery preference',
                'WC Additional Name'
            );
            this._didClearWineClub = true;
        }

        return this.props.renderView(this.props);
    }
}

export default ClearWineclub;